import { z } from 'zod';
export const CrmCommentTarget = z.union([
  z.object({
    userId: z.uuid(),
    eventId: z.never().optional(),
    manyChatContactId: z.never().optional(),
    manualLeadId: z.never().optional(),
    partyId: z.never().optional(),
  }),
  z.object({
    eventId: z.uuid(),
    userId: z.never().optional(),
    manyChatContactId: z.never().optional(),
    manualLeadId: z.never().optional(),
    partyId: z.never().optional(),
  }),
  z.object({
    manyChatContactId: z.uuid(),
    userId: z.never().optional(),
    eventId: z.never().optional(),
    manualLeadId: z.never().optional(),
    partyId: z.never().optional(),
  }),
  z.object({
    manualLeadId: z.uuid(),
    userId: z.never().optional(),
    eventId: z.never().optional(),
    manyChatContactId: z.never().optional(),
    partyId: z.never().optional(),
  }),
  z.object({
    partyId: z.uuid(),
    userId: z.never().optional(),
    eventId: z.never().optional(),
    manyChatContactId: z.never().optional(),
    manualLeadId: z.never().optional(),
  }),
]);
export type CrmCommentTarget = z.infer<typeof CrmCommentTarget>;
export const CrmCommentBody = z.object({ text: z.string().trim().min(1).max(4000) });
export const CrmCommentDto = z.object({
  id: z.uuid(),
  text: z.string(),
  createdAt: z.iso.datetime(),
  author: z.object({ id: z.uuid(), username: z.string().nullable(), firstName: z.string().nullable() }),
});
export type CrmCommentDto = z.infer<typeof CrmCommentDto>;
export const CrmCommentsDto = z.array(CrmCommentDto);
